import { render } from "./ContactUsView.vue?vue&type=template&id=5147f290"
import script from "./ContactUsView.vue?vue&type=script&lang=js"
export * from "./ContactUsView.vue?vue&type=script&lang=js"

import "./ContactUsView.vue?vue&type=style&index=0&id=5147f290&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__